import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "ad-hoc-points",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const adhocPoints = require("./LoyaltyPoints").default;
          cb(null, adhocPoints);
        },
        "LoyaltyPoints"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/LoyaltyPoints/index.js